import React, { PureComponent } from "react";
import { Card, Col, Row, Container, Modal, Button } from "reactstrap";
import MerchantDetailedOrderCard from "../../components/DetailedOrderCard/MerchantDetailedOrderCard";
import DetailedOrderCard from "../DetailedOrderCard";
import moment from "moment";
import Countdown from "react-countdown-now";

const rendererTimer = ({ minutes, seconds, completed }) => {
  if (completed) {
    // Render a complete state
    return (
      <p
        style={{
          paddingLeft: 2,
          paddingRight: 2,
          fontSize: 25,
          textAlign: "center",
        }}
      >
        00:00{" "}
      </p>
    );
  } else {
    // Render a countdown
    return (
      <p
        style={{
          paddingLeft: 2,
          paddingRight: 2,
          fontSize: 25,
        }}
      >
        {minutes}:{seconds}
      </p>
    );
  }
};

export default class OrderCard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      orderModalVisible: false,
    };
    // console.log('prop order',this.props.order );
  }

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible,
    });
  };

  getCountOfItems = () => {
    let cartItems = this.props.order.node.cart.cartItems.edges;
    let quantity = 0;
    cartItems.forEach((cartItem) => {
      quantity = quantity + cartItem.node.quantity;
    });

    return quantity;
  };

  getBackgroundColor = () => {
    // eslint-disable-next-line
    switch (this.props.order.node.status) {
      case "PUSHED":
        return "p-0 bg-success";
      case "ACCEPTED":
        switch (this.props.order.node.customerStatus) {
          case "APPROACHING":
            return "p-0 bg-warning";

          case "ARRIVED":
            return "p-0 bg-danger";

          default:
            return "p-0";
        }
      case "READY":
        switch (this.props.order.node.customerStatus) {
          case "APPROACHING":
            return "p-0 bg-warning";

          case "ARRIVED":
            return "p-0 bg-danger";

          default:
            return "p-0 bg-warning";
        }
    }
  };
  /* peri changes for large font */

  getTokenFontSize() {
    // You can adjust these values as per your requirement
    if (this.state.screenWidth >= 1200) {
      return 40;
    } else if (this.state.screenWidth >= 992) {
      return 30;
    } else if (this.state.screenWidth >= 768) {
      return 20;
    } else {
      return 16;
    }
  }

  render() {
    let vehicleDetails = this.props.order.node.cart.checkout.mode;
    let vehicleString = "Walking";
    let tableNo = "";
    if (!!vehicleDetails) {
      vehicleString = vehicleDetails;
      if (
        this.props.order.node.cart.checkout &&
        this.props.order.node.cart.checkout.mode !== null
      ) {
        if (vehicleString === "TABLE_SERVICE") {
          if (this.props.order.node.cart.checkout.deliveryLocation !== null) {
            tableNo = this.props.order.node.cart.checkout.deliveryLocation;
          }
        }
      }
    }
    let loginMode = localStorage.getItem("loginMode");

    return (
      <div>
        <Card
          className={this.getBackgroundColor()}
          style={{
            display: "flex",
            margin: 10,
            color: "black",
          }}
        >
          {loginMode === "merchant" ? (
            <Modal
              size="lg"
              isOpen={this.state.orderModalVisible}
              toggle={this.toggleModal}
            >
              <MerchantDetailedOrderCard
                editable={true}
                order={this.props.order}
                toltalItemCount={null}
                goBack={this.toggleModal}
                pastOrder={false}
                bussiness={this.props.bussiness}
                storeInformation={this.props.storeInformation}
                refreshOrders={this.props.refreshOrders}
              />
            </Modal>
          ) : (
            <Modal
              size="lg"
              isOpen={this.state.orderModalVisible}
              toggle={this.toggleModal}
            >
              <DetailedOrderCard
                editable={true}
                order={this.props.order}
                toltalItemCount={null}
                goBack={this.toggleModal}
                pastOrder={false}
                bussiness={this.props.bussiness}
                storeInformation={this.props.storeInformation}
                refreshOrders={this.props.refreshOrders}
              />
            </Modal>
          )}
          <Container
            fluid
            style={{ padding: 0 }}
            onClick={() => {
              this.toggleModal();
              this.props.cardSelected();
            }}
          >
            <Row>
              <Col xs="12">{this.renderHeader()}</Col>
            </Row>
            <Row noGutters style={{ alignItems: "center" }}>
              <Col xs="4" className="p-0 border-right">
                <div
                  style={{
                    display: "flex",
                    height: "100%",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <p style={{ margin: 0, padding: 0 }}>TOKEN</p>
                  <p style={{ fontSize: this.getTokenFontSize(), margin: 0, padding: 0 }}>
                    {"" + this.getToken()}
                  </p>
                  {this.props.order.node.status === "READY" ? (
                    <p
                      style={{
                        margin: 0,
                        padding: 0,
                        textAlign: "center",
                      }}
                    >
                      Order is Ready
                    </p>
                  ) : this.props.order.node.status !== "PUSHED" ? (
                    <div>
                      <p style={{ margin: 0, padding: 0, fontSize: 12 }}>
                        Time Remaining
                      </p>
                      <Countdown
                        date={
                          loginMode === "merchant"
                            ? moment() + 0
                            : moment() + this.getCountDownTime()
                        }
                        renderer={rendererTimer}
                      />
                    </div>
                  ) : null}
                </div>
              </Col>

              <Col xs="8">
                <div className="d-flex flex-column align-items-left p-2">
                  <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                    {"Mode: " + vehicleString}
                  </p>
                  {tableNo !== "" ? (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {tableNo}
                    </p>
                  ) : null}
                  {this.getPaymentMode() === "PAY_AT_COUNTER" ? (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {"Pay at Counter"}
                    </p>
                  ) : null}
                  {/* <Button
                    style={{
                      padding: 2,
                      fontWeight: "bold",
                      color: "white",
                      backgroundColor:
                        this.getPaymentBackgroudColor() === true
                          ? "green"
                          : "red",
                    }}
                  >
                    {this.getPayment()}
                  </Button> */}
                {this.props.order.node.deliveryEndtime != null ? (
                  <Button
                    style={{
                      padding: 2,
                      fontWeight: "bold",
                      color: "white",
                      backgroundColor:"red"
                       
                    }}
                  >
                    PRIORITY
                  </Button>
                ):null}
                  {this.props.order.node.cart.checkout.codeType === "AEP" ? (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {this.props.order.node.cart.checkout.codeType +
                        ": " +
                        this.props.order.node.cart.checkout.code}
                    </p>
                  ) : null}
              
                <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                  {this.props.order.node.cart.pickupPoint.store.fetchCutomerDetails === false ? (
                  "Phone: " + this.props.order.node.user.phone
                  ): "Order: " + this.props.order.node.orderId}
                  </p>
           
                  {this.props.order.node.deliveryEndtime != null ? (
                  <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                    {/* {"Pickup Point: " +
                      this.props.order.node.cart.pickupPoint.name} */}
                      {"Delivery: " +
                      moment(this.props.order.node.deliveryEndtime).format("MMMM Do YYYY, h:mm a")}
                  </p>
                    ) : null}
                  
                </div>
              </Col>  
            </Row>
          </Container>
        </Card>
      </div>
    );
  }

  getPaymentMode = () => {
    let mode = this.props.order.node.cart.checkout.payments.edges[0].node.mode;

    return mode;
  };

  getPayment = () => {
    let total = this.props.order.node.cart.total;
    let payments = this.props.order.node.cart.checkout.payments.edges;
    let paid = false,
      paidText = "Payment Pending";
    for (let i = 0; i < payments.length; i++) {
      if (
        (payments[i].node.status === "SUCCESS" ||
          payments[i].node.status === "PROCESSED") 
          /*&&
        // eslint-disable-next-line
        parseInt(payments[i].node.amount) >= parseInt(total)
        */
      ) {
        paid = true;
      }
    }
    if (paid) {
      paidText = "PAID";
    }
    return paidText;
  };
  getPaymentBackgroudColor = () => {
    let total = this.props.order.node.cart.total;
    let payments = this.props.order.node.cart.checkout.payments.edges;
    let paid = false;

    for (let i = 0; i < payments.length; i++) {
      if (
        (payments[i].node.status === "SUCCESS" ||
          payments[i].node.status === "PROCESSED") 
          /*&&
        // eslint-disable-next-line
        parseInt(payments[i].node.amount) >= parseInt(total)
        */
      ) {
        paid = true;
      }
    }
    return true;
    // return paid;
  };

  getToken = () => {
    let token = JSON.stringify(this.props.order.node.storeToken);
    // if (token.length <= 4) {
    //   if (token.length === 1) {
    //     token = "000" + token;
    //   } else if (token.length === 2) {
    //     token = "00" + token;
    //   } else if (token.length === 3) {
    //     token = "0" + token;
    //   }
    // }
    return token;
  };

  getCountDownTime = () => {
    try {
    let readyTime;
    let ms;
    if (this.props.order.node.deliveryEndtime != null){
      readyTime = moment(this.props.order.node.deliveryEndtime);
      ms =
      moment.duration(readyTime.diff(moment())).minutes() * 60 * 1000 +
      moment.duration(readyTime.diff(moment())).seconds() * 1000;
    }
    else if (this.props.order.node.deliveryEndtime == null && this.props.order.node.pushedAt !== null) {
      if (this.props.order.node.sla !== null)
        readyTime = moment(this.props.order.node.pushedAt).add(
          this.props.order.node.sla,
          "s"
        );
      else readyTime = moment(this.props.order.node.pushedAt).add(900, "s");

      ms =
        moment.duration(readyTime.diff(moment())).minutes() * 60 * 1000 +
        moment.duration(readyTime.diff(moment())).seconds() * 1000;
    } else {
      ms = 0;
    }
    return ms;
  } catch (error) {
    console.log("getCountDownTime ordercard function", error);
    return 0;
}
  };
  renderHeader = () => {
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "store") {
      return <div />;
    } else if (loginMode === "merchant") {
      return (
        <div className="border-bottom" style={{ padding: 10 }}>
          <h5>{this.props.order.node.cart.pickupPoint.name}</h5>
        </div>
      );
    }

    return <div />;
  };
}



// WEBPACK FOOTER //
// ./src/components/OrderCard/OrderCard.js